import { render, staticRenderFns } from "./ProductTagModal.vue?vue&type=template&id=3996f5ec&"
import script from "./ProductTagModal.vue?vue&type=script&lang=js&"
export * from "./ProductTagModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3996f5ec')) {
      api.createRecord('3996f5ec', component.options)
    } else {
      api.reload('3996f5ec', component.options)
    }
    module.hot.accept("./ProductTagModal.vue?vue&type=template&id=3996f5ec&", function () {
      api.rerender('3996f5ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/carnival/orderMgt/modules/ProductTagModal.vue"
export default component.exports